<template>
<div class="chapter">
<div class="inner_page">
<p class="h1" id="toc">The Good and Beautiful<br/>
  Community</p>
<p class="first"> </p>
<p class="h3" id="heading_id_2">Following the Spirit,<br/>
  Extending Grace,<br/>
  Demonstrating Love</p>
<p class="first"> </p>
<p class="first"> </p>
<p class="h3">James Bryan Smith</p>
<p class="first"> </p>
<p class="h2"><img alt="IVP Books" src="Images/IVP_Books_Quarter.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?139ffbc4